import { IAuctionStrategy } from '../../../../../redux/reducers';
import { IAuctionStrategyInfoSchema } from '../../internalTypes';

export function mapAuctionStrategy(auctionStrategyInfo?: IAuctionStrategyInfoSchema | null): IAuctionStrategy {
  const { isEnabled, serviceTypes, strategyName } = auctionStrategyInfo || {};

  return {
    isEnabled: isEnabled || false,
    serviceTypes: serviceTypes || [],
    strategyName: strategyName || '',
  };
}
